module.exports = __webpack_public_path__ + "media/images/team/SRaluca-524e07a91c10b5c64dbeba9c7da886be.jpg";